<template>
  <div>
    <el-card shadow="never" style="padding-bottom: 15px">
      <el-page-header v-if="flag === 'regular'" :content="headerTitle" title="" class="page-header" @back="$router.push('/payroll-report')"/>
      <el-page-header v-else :content="headerTitle" title="" class="page-header" @back="$router.push('/sp/report')"/>
      <el-button v-if="ids.length > 0" type="success" style="float: right; margin-top: -40px;" @click="emailPayslip"><i class="el-icon-message"/> Send Email</el-button>
    </el-card>
    <el-row :gutter="6" >
      <el-col :xs="12" :sm="12" :md="12" :lg="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="color: #0a8700">Personnel List <i class="el-icon-user"/></span>
            <div style="margin-top: 15px;">
              <el-input v-model="search" placeholder="Search here ...">
                <el-button slot="append" @click="getPersonnelList">Search</el-button>
              </el-input>
            </div>
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :element-loading-text="infotext"
            :data="personnelList"
            size="medium"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55"/>
            <el-table-column label="Personnel name" prop="fullname"/>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getPersonnelList"/>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="color: #0a8700">Success email <i class="el-icon-check"/></span>
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :element-loading-text="infotext"
            :data="personnelListSuccess"
            size="medium"
            style="width: 100%">
            <el-table-column label="Personnel name" prop="fullname"/>
            <el-table-column width="120" align="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" plain @click="resendEmail(scope.row)">Resend</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="metaS.per_page" :pager-count="7" :total="metaS.total" :current-page.sync="metaS.page" layout="total, prev, pager, next" @current-change="getPersonnelListSuccess"/>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="color: red">Failed email <i class="el-icon-close"/></span>
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :element-loading-text="infotext"
            :data="personnelListFailed"
            size="medium"
            style="width: 100%">
            <el-table-column label="Personnel name" prop="fullname"/>
            <el-table-column width="120" align="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" plain @click="resendEmail(scope.row)">Resend</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="metaF.per_page" :pager-count="7" :total="metaF.total" :current-page.sync="metaF.page" layout="total, prev, pager, next" @current-change="getPersonnelListFailed"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Report } from '../../../api/payroll/report'
import { NotifyError, NotifySuccess } from '../../../helper/Helper'
export default {
  name: 'PersonnelList',
  data() {
    return {
      search: null,
      flag: this.$route.params.flag,
      infotext: 'Please wait...',
      astatus: parseInt(this.$store.getters.APStatus),
      tenure: '',
      headerTitle: '',
      metaS: {
        page: 1
      },
      metaF: {
        page: 1
      },
      meta: {
        page: 1
      },
      loading: false,
      emailLoading: null,
      personnelList: [],
      personnelListSuccess: [],
      personnelListFailed: [],
      multipleSelection: [],
      ids: [],
      scholar: 0,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id,
      months: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  created() {
    if (this.$route.params.scope === 'scholar') {
      this.scholar = 1
    }
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    this.tenure = this.astatus === 3 ? 'Permanent' : 'casCon'
    this.headerTitle = 'Payroll for the month of ' + this.months[this.$route.params.month] + ' ' + this.$route.params.year
    this.getPersonnelList()
    this.getPersonnelListFailed()
    this.getPersonnelListSuccess()
  },
  mounted() {
    if (this.$echo) {
      this.$echo.channel('payslip-email')
        .listen('PayslipEmailStatusUpdated', (event) => {
          if (Number(event.userId) === Number(this.$store.getters.user.currentUser.id) || Number(event.user_id) === Number(this.$store.getters.user.currentUser.id)) {
            if (this.emailLoading) {
              this.emailLoading.close()
              this.emailLoading = null
            }
            if (event.payload && event.payload.status === 'sent') {
              this.$message.success(event.payload.message || 'Payslip email sent successfully.')
            } else if (event.payload) {
              this.$message.error(event.payload.message || 'Failed to send payslip email.')
            }
            this.getPersonnelList()
            this.getPersonnelListFailed()
            this.getPersonnelListSuccess()
          }
        })
    }
  },
  beforeDestroy() {
    if (this.$echo) {
      this.$echo.leave('payslip-email')
    }
  },
  methods: {
    getPersonnelListSuccess() {
      this.loading = true
      Report({ page: this.metaS.page, scope: this.scholar, control_number: this.$route.params.cnumber, year: this.$route.params.year, month: this.$route.params.month, sent: 1 }, 'get', 'getPersonnelList').then(res => {
        this.personnelListSuccess = res.data.list
        this.metaS = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    getPersonnelListFailed() {
      this.loading = true
      Report({ page: this.metaF.page, scope: this.scholar, control_number: this.$route.params.cnumber, year: this.$route.params.year, month: this.$route.params.month, sent: 0 }, 'get', 'getPersonnelList').then(res => {
        this.personnelListFailed = res.data.list
        this.metaF = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    getPersonnelList() {
      this.loading = true
      Report({ page: this.meta.page, search: this.search, scope: this.scholar, control_number: this.$route.params.cnumber, year: this.$route.params.year, month: this.$route.params.month }, 'get', 'getPersonnelList').then(res => {
        this.personnelList = res.data.list
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.ids = []
      this.retval = []
      val.forEach(index => {
        this.retval.push(index.hpperid)
      })
      this.ids = this.retval
    },
    resendEmail(row) {
      this.$confirm('Are you sure you want to resend this payslip to ' + row.fullname + '?', 'Warning', {
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        type: 'warning',
        center: true
      }).then(() => {
        this.emailLoading = this.$loading({
          lock: true,
          text: 'Sending payslip email. Please wait...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        Report({ ids: [row.hpperid], year: this.$route.params.year, status: true, astatus: this.astatus, month: this.$route.params.month, option: this.$route.params.scope, type: 'payslip', control_number: this.$route.params.cnumber, tenure: this.tenure, campus_id: this.campus_id }, 'get', 'emailPayslip').then(res => {
          if (res.data.success === true) {
            NotifySuccess(res.data.message)
          } else {
            NotifyError(res.data.message)
            if (this.emailLoading) {
              this.emailLoading.close()
              this.emailLoading = null
            }
          }
        }).catch(error => {
          console.log(error)
          if (this.emailLoading) {
            this.emailLoading.close()
            this.emailLoading = null
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Cancelled'
        })
      })
    },
    emailPayslip() {
      this.$confirm('Are You Sure! You Want to Sent this Payslip to All Employees?', 'Warning', {
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        type: 'warning',
        center: true
      }).then(() => {
        this.emailLoading = this.$loading({
          lock: true,
          text: 'Sending payslip emails. Please wait...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        Report({ ids: this.ids, year: this.$route.params.year, status: true, astatus: this.astatus, month: this.$route.params.month, option: this.$route.params.scope, type: 'payslip', control_number: this.$route.params.cnumber, tenure: this.tenure, campus_id: this.campus_id }, 'get', 'emailPayslip').then(res => {
          if (res.data.success === true) {
            NotifySuccess(res.data.message)
          } else {
            NotifyError(res.data.message)
            if (this.emailLoading) {
              this.emailLoading.close()
              this.emailLoading = null
            }
          }
          this.loading = false
        }).catch(error => {
          console.log(error)
          if (this.emailLoading) {
            this.emailLoading.close()
            this.emailLoading = null
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Cancelled'
        })
      })
    }
  }
}
</script>

<style>
.el-page-header__content{
  color: #0a8700;
}
</style>
